import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postCashback = (params) => {
    return axios.post(`${backendHost}/api/admin/cashback`, params);
};